import logo from './logo.svg';
import './App.css';
import Quizeapp from './QuizComponent';
function App() {
  return (
    <>
      <Quizeapp/>
    </>
  );
}
export default App;
